import { Navigate, useParams } from 'react-router'

import { AppResolutionRedirect } from './AppResolutionRedirect'

/**
 * Resolves a bare customer path or unknown app segment through the shared landing chain.
 */
export const AppFallback = () => {
  const { customer, '*': unmatchedPath } = useParams<{
    customer: string
    '*': string
  }>()

  if (customer === undefined) {
    return <Navigate replace to="/unauthorized" />
  }

  const requestedAppId = unmatchedPath?.split('/')[0] || undefined

  return (
    <AppResolutionRedirect
      customer={customer}
      requestedAppId={requestedAppId}
    />
  )
}
